<template>
  <div class="confirmation-container">
    <div v-if="confirmationTokenRequesting" class="loading-wrapper">
      <proa-loading class="loading"/>
    </div>
    <proa-card v-else-if="!invalidConfirmationTokenModal" flat class="confirmation-card">
      <div class="form-wrapper">
        <router-link :to="{ name: 'root' }" class="d-block mb-4 pb-2">
          <img :src="require('@/assets/images/logo.png')" class="logo"/>
        </router-link>
        <div class="mb-4 pb-2 font-weight-w6">{{ $t('pages.confirmation.formCaption') }}</div>
        <validation-observer v-slot="{ handleSubmit }">
          <form novalidate @submit.prevent="() => { validated = true; handleSubmit(onSubmitConfirmation) }">
            <div class="mb-4">
              <validation-provider
                :name="$t('models.user.attributes.password')"
                rules="required|min:8|password"
                v-slot="{ errors }"
                vid="password"
              >
                <proa-input-group :invalidFeedback="validated ? errors[0] : null">
                  <template slot="input">
                    <proa-input
                      v-model="password"
                      type="password"
                      :placeholder="$t('models.user.attributes.password')"
                      :disabled="confirmationRequesting"
                      dark
                    />
                  </template>
                </proa-input-group>
              </validation-provider>
            </div>
            <div class="mb-4">
              <validation-provider
                :name="$t('models.user.attributes.passwordConfirmation')"
                rules="required|confirmed:password"
                v-slot="{ errors }"
              >
                <proa-input-group :invalidFeedback="validated ? errors[0] : null" class="mb-0">
                  <template slot="input">
                    <proa-input
                      v-model="passwordConfirmation"
                      type="password"
                      :placeholder="$t('models.user.attributes.passwordConfirmation')"
                      :disabled="confirmationRequesting"
                      dark
                    />
                  </template>
                </proa-input-group>
              </validation-provider>
              <span class="password-rules">{{ $t('models.user.passwordRules') }}</span>
            </div>
            <div class="mb-4 pt-2 font-weight-w6">{{ $t('pages.confirmation.subFormCaption') }}</div>
            <div class="mb-4">
              <validation-provider
                :name="$t('models.user.organizationName')"
                rules="required|max:50"
                v-slot="{ errors }"
              >
                <proa-input-group :invalidFeedback="validated ? invalidOrganizationName ? $t('pages.confirmation.invalidOrganizationName') : errors[0] : null" class="mb-0">
                  <template slot="input">
                    <proa-input
                      v-model="organizationName"
                      type="text"
                      :placeholder="$t('models.user.organizationName')"
                      :disabled="confirmationRequesting"
                      dark
                    />
                  </template>
                </proa-input-group>
              </validation-provider>
            </div>
            <div class="py-2 mb-4">
              <proa-button
                class="w-100"
                type="submit"
                variant="primary"
                :loading="confirmationRequesting"
              >
                {{ $t('common.register') }}
              </proa-button>
            </div>
          </form>
        </validation-observer>
      </div>
    </proa-card>
    <proa-modal
      :modal="invalidConfirmationTokenModal"
      :title="$t('pages.confirmation.invalidConfirmationTokenModal.title')"
      @close="$router.push({ name: 'service' })"
      hideCloseButton
    >
      <div class="text-pre-wrap">
        <span>{{ $t('pages.confirmation.invalidConfirmationTokenModal.body') }}</span>
      </div>
    </proa-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Confirmation',
  data () {
    return {
      password: '',
      passwordConfirmation: '',
      organizationName: '',
      confirmationTokenRequesting: true,
      confirmationRequesting: false,
      invalidConfirmationTokenModal: false,
      invalidOrganizationName: false,
      validated: false
    }
  },
  computed: {
    confirmationToken: function() { return this.$route.query.token },
    ...mapGetters({
      httpError: 'httpError'
    })
  },
  methods: {
    async onSubmitConfirmation() {
      this.confirmationRequesting = true
      await this.confirmation({
        password: this.password,
        passwordConfirmation: this.passwordConfirmation,
        organizationName: this.organizationName,
        confirmationToken: this.confirmationToken
      })
      this.confirmationRequesting = false

      if (this.httpError) {
        if (this.httpError.response?.data?.errors?.name) this.invalidOrganizationName = true
      } else {
        this.$router.push({ name: 'mySpace' })
      }
    },
    ...mapActions({
      validateConfirmation: 'auth/validateConfirmation',
      confirmation: 'auth/confirmation'
    })
  },
  async created() {
    await this.validateConfirmation({
      confirmation_token: this.confirmationToken
    })

    // TODO: メール再送案内
    if (this.httpError) this.invalidConfirmationTokenModal = true
    this.confirmationTokenRequesting = false
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.confirmation-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirmation-card {
  width: 100%;

  @include mq(sm) {
    width: 400px;
  }
}

.password-rules {
  display: block;
  margin-top: 20px;
  white-space: pre-wrap;
  font-size: 12px;
  color: $light-text-color;
}

.form-wrapper {
  padding: 40px 50px;
  text-align: center;

  .logo {
    width: 150px;
  }
}

.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 40px;

  .loading {
    width: 80px;
    height: 80px;
  }
}

</style>
